import script from "./WashingMarkSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./WashingMarkSelect.vue?vue&type=script&lang=ts&setup=true"

import "./WashingMarkSelect.vue?vue&type=style&index=0&id=3893789e&lang=scss&scoped=true"
import "./WashingMarkSelect.vue?vue&type=style&index=1&id=3893789e&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3893789e"]])

export default __exports__